<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import CustomLoader from "@/components/widgets/custom-loader";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Manage Student Distances",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CustomLoader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Manage Student Distances",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Manage Student Distances",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 550,
      pageOptions: [550, 1000, 1500, 2000, 2500],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "student",
          label: "Student's Name",
          sortable: true,
        },
        {
          key: "residence",
          label: "Residence",
          sortable: true,
        },
        {
          key: "streamx",
          label: "Stream",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "Action",
        },
      ],
      mydata: {
        sid: "",
        distance: "",
      },
      filterData: {
        class: "",
        term: "",
        year: "",
        stream: "",
      },
      myStudents: [],
      selectedStream: [],
      selectedClass: [],
    };
  },
  computed: {
    ...mapGetters("students", [
      "AllStudents",
      "SaveStatus",
      "FetchingStudents",
    ]),
    ...mapGetters("classes", ["AllStreams", "AllClasses", "AllClassStreams"]),
    ...mapGetters("marks", ["getYears"]),
    ...mapGetters("transport", ["AllDistances"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.myStudents ? this.myStudents.length : 1;
    },
  },
  watch: {
    AllStudents(newVal) {
      if (newVal) {
        this.assignData();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AllStudents ? this.AllStudents.length : 1;
  },
  methods: {
    ...mapActions({
      FetchStudents: "students/fetchStudents",
      FetchClasses: "classes/fetchClasses",
      FetchDistances: "transport/fetchAllDistances",
      FetchClassStreams: "classes/fetchClassStreams",
      SaveDistance: "transport/saveDistance",
      FetchYears: "marks/fetchYear",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.myStudents.length;
      this.currentPage = 1;
    },
    assignData(){
      this.myStudents = this.AllStudents;
    },
    SaveChanges(distance,eId){
      this.SaveDistance({distance:distance,eId:eId});
    },

    fetchStreamsinClass(event) {
      const id = event.target.value;
      const classSelected = {
        id,
      };
      //fetching class streams
      this.FetchClassStreams(classSelected);
    },

    submitFilter() {
      this.FetchStudents(this.filterData);
    },
  },
  created() {
    this.FetchYears();
    this.FetchClasses();
    this.FetchDistances();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_students')
        )
      "
    >
      <div class="col-12">
        <b-card no-body class="mb-1 shadow-none">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a
                v-b-toggle.accordion-1
                class="text-primary"
                href="javascript: void(0);"
                ><u> Click to Filter Students</u>
                <i class="fa fa-filter" aria-hidden="true"></i
              ></a>
            </h6>
          </b-card-header>
          <b-collapse
            id="accordion-1"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <form @submit.prevent="submitFilter()">
                <div class="row">
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for=""
                        >Year <small class="text-danger">*</small></label
                      >
                      <select
                        class="form-control form-control-sm"
                        required
                        v-model="filterData.year"
                        name=""
                        id=""
                      >
                        <option value="" selected disabled>Select Year</option>
                        <option
                          v-for="(schyear, index) in getYears"
                          :value="schyear.year"
                          :key="index"
                        >
                          {{ schyear.year }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for=""
                        >Term <small class="text-danger">*</small></label
                      >
                      <select
                        required
                        class="form-control form-control-sm"
                        v-model="filterData.term"
                        name=""
                        id=""
                      >
                        <option value="" selected disabled>Select Term</option>
                        <option value="1">Term 1</option>
                        <option value="2">Term 2</option>
                        <option value="3">Term 3</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for=""
                        >Class <small class="text-danger">*</small></label
                      >
                      <select
                        class="form-control form-control-sm"
                        required
                        v-model="filterData.class"
                        @change="fetchStreamsinClass($event)"
                        name=""
                        id=""
                      >
                        <option value="" selected disabled>Select Class</option>
                        <option
                          v-for="(classes, index) in AllClasses"
                          :key="index"
                          :value="classes.id"
                        >
                          {{ classes.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for=""
                        >Stream
                        <small class="text-primary">(Optional)</small></label
                      >
                      <select
                        class="form-control form-control-sm"
                        v-model="filterData.stream"
                        name=""
                        id=""
                      >
                        <option v-if="SaveStatus" value="" selected disabled>
                          Fetching Streams...
                        </option>
                        <option v-else value="" selected disabled>
                          Select Stream
                        </option>
                        <option
                          v-for="(stream, index) in AllClassStreams"
                          :value="stream.id"
                          :key="index"
                        >
                          {{ stream.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3 mt-3">
                    <button
                      type="submit"
                      size="sm"
                      disabled
                      class="btn btn-sm btn-outline-primary mt-2"
                      v-if="FetchingStudents"
                    >
                      <b-spinner
                        variant="primary"
                        small
                        label="Fetching Data..."
                      ></b-spinner>
                      Fetching Data...
                    </button>
                    <button
                      v-else
                      type="submit"
                      size="sm"
                      class="btn btn-sm btn-outline-primary mt-2"
                    >
                      <i class="fa fa-check"></i>
                      Submit Filers
                    </button>
                  </div>
                </div>
              </form>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <CustomLoader v-if="FetchingStudents"></CustomLoader>
      <div class="col-12" v-else>
        <div class="card" v-if="myStudents">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 col-sm-6 col-xs-12">
                <h3 class="card-title text-primary">List of Student Distances</h3>
              </div>
              <div class="col-md-6 col-sm-6 col-xs-12">
                
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0">
              <b-table
                class="datatables student-list"
                :items="myStudents"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(student)="data">
                  {{ data.item.student.name }}
                </template>
                <template #cell(actions)="data">
                  <model-list-select
                      required
                      :list="AllDistances ? AllDistances : []"
                      v-model="data.item.location"
                      option-value="id"
                      option-text="name"
                      class="mb-2"
                      placeholder="Select Distance"
                      @input="SaveChanges(data.item.location,data.item.id)"
                    >
                    </model-list-select>
                </template>
                <template #cell(residence)="data">
                  {{ data.item.residence == "0" ? "Day" : "Boarding" }}
                </template>
                <template #cell(classx)="data">
                  {{ data.item.classx.short }}
                </template>
                <template #cell(streamx)="data">
                  {{ data.item.streamx.name }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-else>
          <div class="card-body">
            <div class="alert alert-primary text-center" role="alert">
              <span>Please Filter to View Student Distances</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
